<main #mainElement class="w-full show">
	<lbca-input-text-condensed
		[maskInput]="'TIME'"
		[tabeled]="isTabeled"
		[labeled]="!isLabeled"
		[editable]="isEditable"
		[disabled]="isDisabled"
		[require]="isRequired"
		[helperText]="helperTextValue"
		[label]="labelValue"
		(focusState)="setFocus($event)"
		[componetIconStyle]="componetIconStyle"
		(change)="change($event)"
		(click)="click()"
		[hasExternalError]="hasError"
		[value]="valueInput"
	></lbca-input-text-condensed>
</main>

<ng-template cdkPortal #templateAppend="cdkPortal">
	<div
		(mousedown)="eventBlockFocusOut($event)"
		class="timepicker-template-condensed"
		[class.inactive]="hideHour"
		[class.active]="!hideHour"
		[ngClass]="helperTextValue && helperTextValue !== '' ? 'mt-[18px]' : 'mt-[12px]'"
	>
		<div class="tpk-arrow"></div>

		<section class="tpk-time">
			<div class="tpk-tit-labels">
				<div class="tpk-tit">{{ fieldsLabels['hour'] }}</div>
			</div>

			<div class="tpk-struct">
				@for (hour of hours; track hour) {
					<div class="tpk-row">
						<div class="tpk-round">
							<div class="tpk-time-label" (click)="select(hour, 0)">
								{{ hour }}
							</div>
						</div>
					</div>
				}
			</div>
		</section>
	</div>

	<div
		(mousedown)="eventBlockFocusOut($event)"
		class="timepicker-template"
		[class.active]="!hideMinutes"
		[class.inactive]="hideMinutes"
		[class.ml-[20px]]="!hideHour"
		[ngClass]="helperTextValue && helperTextValue !== '' ? 'mt-[18px]' : 'mt-[12px]'"
	>
		<div class="tpk-arrow"></div>

		<section class="tpk-time">
			<div class="tpk-tit-labels">
				<div class="tpk-tit">{{ fieldsLabels['minute'] }}</div>
			</div>

			<div class="tpk-struct">
				@for (min of minutes; track min) {
					<div class="tpk-row">
						<div class="tpk-round">
							<div (click)="select(min, 1)" class="tpk-time-label">
								{{ min }}
							</div>
						</div>
					</div>
				}
			</div>
		</section>
	</div>
</ng-template>
